// extracted by mini-css-extract-plugin
export default {"characterButton":"character-button_characterButton__meVDR"};